@let config = activeConfig();
@let label = config.switchToKey | translate;
<p-button
  variant="text"
  [icon]="config.icon"
  [attr.aria-label]="label"
  [attr.title]="label"
  (onClick)="toggleTheme()"
  data-testid="select-theme"
></p-button>
